<app-template-preview [control]="control" [value]="value" [disabled]="disabled" (preview)="setBarcode($event)">{{ "FORM.THREATS.BOOL.BAE" }}</app-template-preview>
